
import Vue from 'vue'
import TopSearchControl from '@/common/components/TopSearchControl.vue'
import ProductCategories from '@/common/components/sidebar/ProductCategories.vue'
import PaymentInfo from '@/common/components/sidebar/PaymentInfo.vue'
import FacetsList from '@/common/components/facets/FacetsList.vue'

import { MaxQuantityPrice  } from '@/common/types/maxQuantityPrice'

export default Vue.extend({
  components: {
    // NOTE: VueComponent.name option is not working...
    SidebarTopSearch: TopSearchControl,
    SidebarProductCategories: ProductCategories,
    SidebarPaymentInfo: PaymentInfo,
    FacetsList
  },
  props: {
    productCategories: {
      type: Array,
      required: true
    },
    flagTopSearch: {
      type: Boolean,
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  computed: {
    sidebarVisible(): boolean {
      return window.innerWidth > 1024
    }
  }
})
